import ChargeHelper from 'features/Charge/chargeHelper';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTBSDropdown, { KTBSDropdownDirections } from 'general/components/OtherKeenComponents/KTBSDropdown';
import KTRadio, { KTRadioType } from 'general/components/OtherKeenComponents/KTFormControls/KTRadio';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import KTPagination, {
  KTPaginationColor,
} from 'general/components/OtherKeenComponents/KTPagination';
import KTTable from 'general/components/OtherKeenComponents/KTTable';
import tableStyle from 'general/components/OtherKeenComponents/KTTable/tableStyle';
import CustomDateRangePicker, {
  dateFilter,
  getDateFilterOption,
} from 'general/components/Others/CustomDateRangePicker';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import AppRoute from 'general/constants/AppRoute';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import * as ExcelJS from 'exceljs';

DriverPaymentHistoryView.propTypes = {
  hasAppTab: PropTypes.bool,
  driverId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  driverDetail: PropTypes.object,
};

function DriverPaymentHistoryView({ hasAppTab = false, driverId, driverDetail }) {
  // MARK: ---- PROPERTIES ----
  const [loading, setIsLoading] = useState(false);
  const [filter, setFilter] = useState({
    q: '',
    page: 0,
    limit: AppConfigs.defaultPageLimit,
    status: '',
    from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
    to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
    dateFilter: dateFilter.baMuoiNgayGanNhat,
  });
  const [timeFilterType, setTimeFilterType] = useState('START_TIME');
  const [paymentList, setPaymentList] = useState([]);
  const [total, setTotal] = useState(0);
  const fullColumns = useMemo(() => {
    return [
      {
        id: 'TRANSACTION_CODE',
        name: UIHelper.buildTableColumn('Mã phiên sạc'),
        selector: (row) => row?.transactionCode ?? row?.transactionId,
        minWidth: '160px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'ENERGY',
        name: UIHelper.buildTableColumn('Lượng điện đã sạc', 'kWh'),
        selector: (row) => (!_.isNil(row?.energy) ? Utils.formatNumber((row?.energy / 1000).toFixed(3)) : ''),
        minWidth: '160px',
        right: true,
        style: tableStyle.columns.normal,
      },
      {
        id: 'AMOUNT',
        name: UIHelper.buildTableColumn('Số tiền sạc', 'VNĐ'),
        selector: (row) => (!_.isNil(row?.totalCost) ? '-' + Utils.formatNumber(row?.totalCost) : ''),
        minWidth: '160px',
        right: true,
        style: tableStyle.columns.danger,
      },
      {
        id: 'PREPAID_AMOUNT',
        name: UIHelper.buildTableColumn('Số tiền trả trước', 'VNĐ'),
        selector: (row) => (!_.isNil(row?.prepaidAmount) ? '-' + Utils.formatNumber(row?.prepaidAmount) : ''),
        minWidth: '160px',
        right: true,
        style: tableStyle.columns.danger,
      },
      {
        id: 'PAYMENT_METHOD',
        name: UIHelper.buildTableColumn('Phương thức thanh toán'),
        selector: (row) => 'Ví điện tử',
        minWidth: '180px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'START_TIME',
        name: UIHelper.buildTableColumn('Thời gian bắt đầu'),
        selector: (row) =>
          !_.isNil(row?.startTime) ? Utils.formatDateTimeToString(row?.startTime, 'DD/MM/YYYY - HH:mm:ss') : '',
        minWidth: '180px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'END_TIME',
        name: UIHelper.buildTableColumn('Thời gian kết thúc'),
        selector: (row) =>
          !_.isNil(row?.endTime) ? Utils.formatDateTimeToString(row?.endTime, 'DD/MM/YYYY - HH:mm:ss') : '',
        minWidth: '180px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'PLATE',
        name: UIHelper.buildTableColumn('Biển số xe'),
        selector: (row) => row?.plate,
        minWidth: '160px',
        style: tableStyle.columns.normal,
      },
      // {
      //   id: 'TRANSACTION',
      //   name: UIHelper.buildTableColumn('Phiên sạc'),
      //   selector: (row) =>
      //     !_.isNil(row?.transactionId) ? (
      //       <span
      //         onClick={() => {
      //           if (!_.isNil(row?.transactionId)) {
      //             Utils.openInNewTab(`${AppRoute.chargeTransactionList}/${row?.transactionId}`);
      //           }
      //         }}
      //         className="cursor-pointer hover-opacity-60"
      //       >
      //         {'Xem chi tiết'}
      //       </span>
      //     ) : (
      //       ''
      //     ),
      //   minWidth: '160px',
      //   style: tableStyle.columns.link,
      // },
      {
        id: 'STATUS',
        name: UIHelper.buildTableColumn('Trạng thái'),
        selector: (row) => {
          return (
            <KTLabel
              text={ChargeHelper.Utils.getChargeTransactionStatusName(row?.status)}
              isInline={true}
              size={KTLabelSize.medium}
              additionalClassName={`label-light-${ChargeHelper.Utils.getChargeTransactionStatusColor(
                row?.status
              )}`}
            />
          );
        },
        minWidth: '180px',
      },
      {
        name: UIHelper.buildTableColumn('Thao tác'),
        width: '80px',
        center: true,
        style: {
          position: 'sticky',
          right: 0,
          backgroundColor: '#fff',
          borderLeft: '1px solid #ebedfe',
        },
        cell: (row) => {
          return UIHelper.buildMoreActionsButton(buildMoreActions(row), true);
        },
      },
    ];
  }, []);
  useEffect(() => {
    setIsLoading(true);
    const params = _.pickBy(
      filter,
      (value) => value !== null && value !== undefined && value !== ''
    );
    ChargeHelper.API.Driver.requestGetDriverChargeSessions(driverId, params)
      .then((response) => {
        setPaymentList(response?.chargeSessions);
        setTotal(response?.total);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [filter]);

  // MARK: ---- METHODS ----
  const buildMoreActions = (row) => {
    const actions = [];
    // xem chi tiet
    actions.push({
      text: 'Xem chi tiết',
      iconElement: <i className="fa-regular fa-eye" style={{ fontSize: '1.1rem' }} />,
      click: () => {
        ChargeHelper.UI.Driver.showDialogTransactionDetail(row, null);
      },
    });
    return actions;
  };

  // xuat file excel
  const handleExportExcel = async (exportData, params) => {
    let exportDataList = exportData;
    if (_.isEmpty(exportDataList)) {
      ToastHelper.showError('Không có dữ liệu để tải xuống');
      return;
    }

    const sheetFileName = driverDetail?.userCode + '_Lịch_sử_sạc_xe_' + moment(params.from).format('DDMMYYYY') + '_' + moment(params.to).format('DDMMYYYY');
    const ext = '.xlsx';
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet(sheetFileName, {
      headerFooter: { firstHeader: sheetFileName },
    });

    sheet.mergeCells('A1:M1');
    sheet.getCell('A1').value = `LỊCH SỬ SẠC XE _${driverDetail?.fullname} (NGÀY ${moment(params.from).format(
      'DD/MM/YYYY'
    )} - ${moment(params.to).format('DD/MM/YYYY')})`;
    sheet.getCell('A1').font = {
      name: 'Times New Roman',
      family: 4,
      size: 11,
      bold: true,
      color: { argb: 'FFFFFFFF' },
    };
    sheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
    sheet.getCell('A1').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '29618E' },
      color: { argb: 'FFFFFF' },
    };
    sheet.getCell('A1').border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
    sheet.getRow(1).height = 25;

    const columns = [
      { key: 'stt', width: 7 },
      { key: 'transactionCode', width: 18 },
      { key: 'startTime', width: 25 },
      { key: 'endTime', width: 22 },
      { key: 'invoiceSerial', width: 22 },
      { key: 'invoiceDate', width: 30 },
      { key: 'customerCode', width: 22 },
      { key: 'customerName', width: 22 },
      { key: 'energy', width: 15 },
      { key: 'amount', width: 20 },
      { key: 'paymentMethod', width: 20 },
      { key: 'plate', width: 20 },
      { key: 'status', width: 20 },
    ];
    sheet.columns = columns;

    sheet.getRow(2).height = 30;
    sheet.getRow(2).font = {
      name: 'Times New Roman',
      family: 4,
      size: 11,
      bold: true,
    };
    sheet.getRow(2).alignment = {
      vertical: 'middle',
      horizontal: 'center',
      wrapText: true,
    };

    sheet.getCell('A2').value = 'STT';
    sheet.getCell('B2').value = 'Mã phiên sạc';
    sheet.getCell('C2').value = 'Thời gian bắt đầu';
    sheet.getCell('D2').value = 'Thời gian kết thúc';
    sheet.getCell('E2').value = 'Số hóa đơn';
    sheet.getCell('F2').value = 'Ngày hóa đơn';
    sheet.getCell('G2').value = 'Mã khách hàng';
    sheet.getCell('H2').value = 'Tên khách hàng';
    sheet.getCell('I2').value = 'Lượng điện đã sạc (kWh)';
    sheet.getCell('J2').value = 'Số tiền sạc (VNĐ)';
    sheet.getCell('K2').value = 'Phương thức thanh toán';
    sheet.getCell('L2').value = 'Biển số xe';
    sheet.getCell('M2').value = 'Trạng thái';


    ['A2:M2'].forEach((range) => {
      sheet.getRow(range.split(':')[0].slice(1)).eachCell({ includeEmpty: true }, (cell) => {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
      });
    });

    let i = 1;
    exportDataList?.forEach((row) => {
      const dataRow = sheet.addRow({
        stt: i++,
        transactionCode: row?.transactionCode ?? row?.transactionId,
        startTime: !_.isNil(row?.startTime) ? Utils.formatDateTimeToString(row?.startTime, 'DD/MM/YYYY - HH:mm') : '',
        endTime: !_.isNil(row?.endTime) ? Utils.formatDateTimeToString(row?.endTime, 'DD/MM/YYYY - HH:mm') : '',
        invoiceSerial: row?.invoiceSerial,
        invoiceDate: !_.isNil(row?.finishedTime) ? Utils.formatDateTimeToString(row?.finishedTime, 'DD/MM/YYYY - HH:mm') : '',
        customerCode: driverDetail?.userCode,
        customerName: driverDetail?.fullname,
        energy: Utils.formatNumber((row?.energy / 1000).toFixed(3) ?? 0),
        amount: Utils.formatNumber(row?.totalCost ?? 0),
        paymentMethod: 'Ví điện tử',
        plate: row?.plate,
        status: ChargeHelper.Utils.getChargeTransactionStatusName(row?.status),
      });

      dataRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
        if (colNumber === 1) {
          cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        } else if (colNumber >= 9 && colNumber <= 10) {
          cell.alignment = { vertical: 'middle', horizontal: 'right', wrapText: true };
        } else {
          cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
        }
      });
    });

    sheet.eachRow((row, rowNumber) => {
      if (rowNumber >= 3) {
        row.font = {
          name: 'Times New Roman',
          family: 4,
          size: 11,
          bold: false,
        };
      }
    });

    workbook.xlsx.writeBuffer().then(function (data) {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = sheetFileName + ext;
      anchor.click();
      window.URL.revokeObjectURL(url);
      ToastHelper.showSuccess('Tải xuống file Excel thành công');
      AppCustomDialogHelper.hide();
    });
  };

  return (
    <div className="pb-4">
      {UIHelper.buildCard(
        <div className="pb-4">
          {/* header */}
          <div className="px-4 pt-4 pb-3 d-flex align-items-center justify-content-between">
            {!hasAppTab && (
              <div className="d-flex flex-column">
                <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
                  Lịch sử sạc xe
                </span>
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                  Tổng:{' '}
                  <span style={UIHelper.buildFontStyle('600', '14px', AppColors.primary)}>
                    {Utils.formatNumber(total)} giao dịch
                  </span>
                </span>
              </div>
            )}
            {/* actions */}
            <div></div>
          </div>

          {/* table */}
          <div className="">
            {/* filter */}
            <div className="w-100 d-flex m-0 p-0 px-2">
              {/* Tìm kiếm */}
              <div className="w-25 mb-4 px-2">
                {UIHelper.buildFormLabel('Tìm kiếm')}
                <KTFormSearch
                  name="paymentHistory_search"
                  placeholder="Theo mã phiên sạc, biển số xe"
                  value={filter.q}
                  onSubmit={(text) => {
                    setFilter({ ...filter, q: text, page: 0 });
                  }}
                />
              </div>

              {/* Trạng thái */}
              <div className="w-25 mb-4 px-2">
                {UIHelper.buildFormLabel('Trạng thái')}
                <KTBSDropdown
                  name="paymentHistory_status"
                  toggleElement={
                    <button
                      className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                      type="button"
                    >
                      {_.find(
                        ChargeHelper.Data.chargeTransactionStatusOptions,
                        (item) => item.value === filter.status
                      )?.name ?? 'Tất cả'}
                    </button>
                  }
                  selectedValue={filter.status}
                  dropdownMenuItems={[
                    { name: 'Tất cả', value: '' },
                    ...ChargeHelper.Data.chargeTransactionStatusOptions,
                  ]}
                  dropdownMenuClassName="overflow-auto w-100"
                  dropdownMenuStyle={{ maxHeight: '30vh' }}
                  onChange={(value) => {
                    setFilter({ ...filter, status: value, page: 0 });
                  }}
                  isDropdownForm={true}
                  direction={KTBSDropdownDirections.up}
                />
              </div>

              <div className="min-w-180px mb-4 px-2 ml-2 d-flex align-items-end"
                style={{
                  borderLeft: `1px solid ${AppColors.gray[300]}`
                }}
              >
                <div className="radio-inline w-100 px-2">
                  <div className="d-flex flex-column">
                    <KTRadio
                      name="startTime"
                      label="Thời gian bắt đầu"
                      type={KTRadioType.outline}
                      additionalClassName="radio-success"
                      onChange={() => {
                        setTimeFilterType('START_TIME')
                        setFilter({
                          ...filter,
                          dateFilter: dateFilter.baMuoiNgayGanNhat,
                          from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
                          to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
                        });
                      }}
                      checked={timeFilterType === 'START_TIME'}
                    />
                    <KTRadio
                      name="endTime"
                      label="Thời gian kết thúc"
                      type={KTRadioType.outline}
                      additionalClassName="radio-success"
                      onChange={() => {
                        setTimeFilterType('END_TIME')
                        setFilter({
                          ...filter,
                          dateFilter: dateFilter.baMuoiNgayGanNhat,
                          from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
                          to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
                        });
                      }}
                      checked={timeFilterType === 'END_TIME'}
                    />
                  </div>
                </div>
              </div>

              {/* Khoảng thời gian */}
              <div className="w-25 mb-4 pr-4"
                style={{
                  borderRight: `1px solid ${AppColors.gray[300]}`
                }}
              >
                {UIHelper.buildFormLabel(timeFilterType === 'START_TIME' ? 'Thời gian bắt đầu' : 'Thời gian kết thúc')}
                <CustomDateRangePicker
                  toggleElementBorderRadius={5}
                  initialValue={filter?.dateFilter}
                  onPressSave={(selectedValue, startDate, endDate) => {
                    setFilter({
                      ...filter,
                      dateFilter: selectedValue,
                      from: startDate,
                      to: endDate,
                      page: 0,
                    });
                  }}
                  direction={KTBSDropdownDirections.up}
                />
              </div>
              <div className="d-flex align-items-center px-4">
                {UIHelper.buildBlueButton(
                  'Tải xuống',
                  async () => {
                    try {
                      ChargeHelper.UI.Excel.showDialogDownloadExcelFile(
                        filter,
                        async (params) => {
                          try {
                            const { chargeSessions = [] } = await ChargeHelper.API.Driver.requestGetDriverChargeSessions(driverId, params);
                            return handleExportExcel(chargeSessions, params);
                          } catch (error) {
                            ToastHelper.showError(`Lỗi khi lấy dữ liệu: ${error.message}`);
                            return [];
                          }
                        },
                      );
                    } catch (error) {
                      ToastHelper.showError(`Lỗi khi khởi tạo tải xuống: ${error.message}`);
                    }
                  },
                  <i className="fa-regular fa-download" style={{ fontSize: 15 }} />
                )}
              </div>
            </div>

            <div className="px-4">
              <KTTable
                columns={fullColumns}
                items={paymentList}
                selectableRows={false}
                striped={false}
                compactGrid={false}
                onClickedRow={(row) => { }}
                onSelectedRowsChanged={(rows) => { }}
                onDoubleClickedRow={(row) => { }}
                noDataComponent={UIHelper.buildEmptyNoData('Không có giao dịch thanh toán nào.')}
              />
            </div>

            <div className="px-4 mt-2">
              <KTPagination
                currentPage={filter.page + 1}
                rowCount={total}
                rowsPerPage={filter.limit}
                currentItemInPageCount={paymentList?.length}
                onChangePage={(newPage) => {
                  const iNewPage = parseInt(newPage);
                  setFilter({ ...filter, page: iNewPage - 1 });
                }}
                onChangeRowsPerPage={(newRowsPerPage) => {
                  const iNewRowsPerPage = parseInt(newRowsPerPage);
                  setFilter({ ...filter, limit: iNewRowsPerPage, page: 0 });
                }}
                loading={false}
                color={KTPaginationColor.success}
                appendText="giao dịch"
              />
            </div>
          </div>
        </div>,
        false,
        false,
        true,
        false,
        AppColors.gray[300],
        hasAppTab
      )}
    </div>
  );
}

export default DriverPaymentHistoryView;
